module.exports = __webpack_public_path__ + "static/banner-f071533480e1fb34ff0298e560f17a0a.png";